(function () {
  'use strict';

  var script = document.currentScript;
  var current = String(script && script.dataset.currentLanguage || document.documentElement.lang || '').toLowerCase().split('-')[0];
  var shopifyCountry = String(script && script.dataset.country || '').toUpperCase();
  var localizedRoot = String(script && script.dataset.localizedRoot || '/');
  var geoUrl = String(script && script.dataset.geoUrl || '').trim();
  var supported = ['de', 'en'];
  if (supported.indexOf(current) === -1) return;

  var preferenceKey = 'melodyglow-language-preference';
  var automaticKey = 'melodyglow-language-auto-v2';

  function storePreference(event) {
    var control = event.target.closest('[data-mg-language-option]');
    if (!control) return;
    try { window.localStorage.setItem(preferenceKey, String(control.value || '')); } catch (ignore) {}
  }

  function switchTo(desired) {
    if (supported.indexOf(desired) === -1 || desired === current) return;
    try {
      var automatic = JSON.parse(window.sessionStorage.getItem(automaticKey) || '{}');
      if (automatic.from === current && automatic.to === desired) return;
      window.sessionStorage.setItem(automaticKey, JSON.stringify({ from: current, to: desired }));
    } catch (ignore) {}

    var option = document.querySelector('[data-mg-language-option][value="' + desired + '"]');
    if (option && option.form) option.form.requestSubmit ? option.form.requestSubmit(option) : option.click();
  }

  document.addEventListener('click', storePreference);

  var saved = '';
  try { saved = String(window.localStorage.getItem(preferenceKey) || ''); } catch (ignore) {}
  if (supported.indexOf(saved) !== -1) {
    switchTo(saved);
    return;
  }

  var explicitLocalePath = localizedRoot !== '/' && new RegExp('^/' + current + '(?:/|$)', 'i').test(window.location.pathname);
  if (explicitLocalePath) return;

  var browserLanguage = String((navigator.languages && navigator.languages[0]) || navigator.language || '').toLowerCase();
  if (['DE', 'AT'].indexOf(shopifyCountry) !== -1 || browserLanguage.indexOf('de') === 0) {
    switchTo('de');
    return;
  }

  if (!/^https:\/\//i.test(geoUrl)) {
    switchTo('en');
    return;
  }

  fetch(geoUrl, { method: 'GET', mode: 'cors', credentials: 'omit', headers: { Accept: 'application/json' } })
    .then(function (response) { if (!response.ok) throw new Error('geo_failed'); return response.json(); })
    .then(function (result) { switchTo(result && result.suggested_language === 'de' ? 'de' : 'en'); })
    .catch(function () { switchTo('en'); });
}());
